import {SecureService} from "@/services/superclasses/secure-service";
import {MemberInvite} from "@/interfaces/member-invite";
import {FormResponse} from "@/interfaces/form-response";

const api = window.contextPath + '/rest/member-invites';

export class MemberInviteSecureService extends SecureService {

    public send = async (email: string): Promise<FormResponse<void>> => {
        return this.data(await this.post(api, {"email": email},
            { headers: {'content-type': 'application/x-www-form-urlencoded'} }));
    }

    public remove = async (id: number): Promise<void> => {
        return this.data(await this.delete(api + "/" + id));
    }

    public loadByMember = async (): Promise<MemberInvite[]> => {
        return this.data(await this.get<MemberInvite[]>(api + "/by-member"))
    };

}

export const memberInviteSecureService = new MemberInviteSecureService();